import { api } from "api";

// ortak boş fonksiyon
const noop = () => {};

export const authenticate = (
  username,
  password,
  emailcode,
  captchaToken,
  onBegin = noop,
  onSuccess = noop,
  onError = noop
) => {
  return async (dispatch) => {
    onBegin();

    try {
      const res = await api.post(
        "/api/auth/login",
        {
          username,
          password,
          emailcode
        },
        {
          headers: {
            "captcha-token": captchaToken
          }
        }
      );

      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data.data,
      });

      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem("expiration", res.data.data.expiration);
      localStorage.setItem("refreshToken", res.data.data.refreshToken);
      localStorage.setItem(
        "refreshTokenExpiration",
        res.data.data.refreshTokenExpiration
      );

      onSuccess();
    } catch (e) {
      dispatch({ type: "LOGIN_ERROR" });
      localStorage.removeItem("token");
      onError(e);
    }
  };
};

export const refreshToken = (
  refreshToken,
  onBegin = noop,
  onSuccess = noop,
  onError = noop
) => {
  return async (dispatch) => {
    onBegin();

    try {
      const res = await api.post("/api/auth/refresh-token-login", {
        refreshToken,
      });

      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem("expiration", res.data.data.expiration);
      localStorage.setItem("refreshToken", res.data.data.refreshToken);
      localStorage.setItem(
        "refreshTokenExpiration",
        res.data.data.refreshTokenExpiration
      );

      onSuccess();
    } catch (e) {
      dispatch({ type: "LOGIN_ERROR" });
      localStorage.removeItem("token");
      onError(e);
    }
  };
};

export const getCompanies = (
  onBegin = noop,
  onSuccess = noop,
  onError = noop
) => {
  return async (dispatch) => {
    onBegin();

    try {
      const res = await api.get("/api/auth/get-companies");
      onSuccess(res.data);
    } catch (e) {
      onError(e);
    }
  };
};

export const setCompany = (
  companyId,
  onBegin = noop,
  onSuccess = noop,
  onError = noop
) => {
  return async (dispatch) => {
    onBegin();

    try {
      const res = await api.post(`/api/auth/set-company/${companyId}`);

      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data.data,
      });

      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem("expiration", res.data.data.expiration);
      localStorage.setItem("refreshToken", res.data.data.refreshToken);
      localStorage.setItem(
        "refreshTokenExpiration",
        res.data.data.refreshTokenExpiration
      );

      onSuccess();
    } catch (e) {
      dispatch({ type: "LOGIN_ERROR" });
      localStorage.removeItem("token");
      onError(e);
    }
  };
};

export const setAuth = (
  token,
  expiration,
  refreshToken,
  refreshTokenExpiration
) => {
  return {
    type: "LOGIN_SUCCESS",
    payload: {
      token,
      expiration,
      refreshToken,
      refreshTokenExpiration,
    },
  };
};

export const logOut = () => {
  let lang = localStorage.getItem("i18nextLng");
  localStorage.clear();
  localStorage.setItem("i18nextLng", lang);
  return { type: "LOGOUT_SUCCESS" };
};